/**
 * Normalize dice faces / legacy rolls from persisted lastRoll.
 * @param {unknown} lastRoll
 * @returns {number[]|null}
 */
export function diceRollValues(lastRoll) {
  if (!lastRoll || typeof lastRoll !== 'object') return null;
  if (Array.isArray(lastRoll.rolls)) return lastRoll.rolls;
  if (Array.isArray(lastRoll.faces)) return lastRoll.faces.map((f) => (typeof f.value === 'number' ? f.value : NaN)).filter((n) => !Number.isNaN(n));
  return null;
}

/**
 * Final total for ribbon / hub (Dice persists total including modifier).
 * @param {unknown} diceState
 * @returns {number|null}
 */
export function diceLastTotal(diceState) {
  const lr = diceState?.lastRoll;
  if (!lr || typeof lr !== 'object' || typeof lr.total !== 'number') return null;
  return lr.total;
}
